import React from 'react';
import { PageContainer } from '../../shared/PageContainer';
import { LdgGraphExplorer } from '../content/ldgGraph';
export function LdgGraphPage() {
  return <div className="h-full flex flex-col bg-white" data-id="element-5188">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200 bg-white flex-shrink-0" data-id="element-5189">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-5190">
          Leerpad Graaf (LDG)
        </h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-5191">
          Interactieve visualisatie van alle vraagfamilies en hun onderlinge
          afhankelijkheden.
        </p>
      </div>

      {/* Graph Explorer - takes full remaining height */}
      <div className="flex-1 relative overflow-hidden" data-id="element-5192">
        <LdgGraphExplorer data-id="element-5193" />
      </div>
    </div>;
}